import { Tooltip } from "@mui/material";
import React from "react";

export default function IMemo(props) {
  const [value, setValue] = React.useState(props.Text);
  const [openTooltip, setOpenTooltip] = React.useState(false);
  const [countChars, setCountChars] = React.useState(props.Text ? props.Text.length : 0);
  const counter = React.useRef(undefined);

  function onOpenToolTip() {
    setOpenTooltip(true);
  }

  function onCloseToolTip() {
    setOpenTooltip(false);
  }

  function getHint() {
    if (props.showHint) return props.hint;
    return "";
  }
  React.useEffect(() => {
    setValue(props.Text);
    setCountChars(props.Text ? props.Text.length : 0);
  }, [props.Text]);

  return (
    <Tooltip open={openTooltip} arrow placement="bottom-start" title={getHint()}>
      <div style={{ height: "100%", width: "100%" }}>
        <div style={{ height: `calc(100% - ${props.hideCharCount ? "0px" : "24px"})`, width: "100%" }}>
          <textarea
            id={props.id}
            onMouseEnter={onOpenToolTip}
            onMouseLeave={onCloseToolTip}
            placeholder={props.placeholder || ""}
            value={value}
            keyname={props.keyName}
            key={props.keyName}
            readOnly={props.readOnly}
            style={props.style}
            onChange={(event) => {
              setValue(event.target.value);
              setCountChars(event.target.value.length);
              if (props.onChange) {
                props.onChange(event);
              }
            }}
            onBlur={(ev) => {
              if (props.onBlur) props.onBlur(ev);
            }}
            onPaste={props.onPaste}
          />
        </div>
        <div
          style={{
            width: "100%",
            height: "23px",
            paddingLeft: "5px",
            display: props.hideCharCount ? "none" : "inline-flex",
            alignItems: "center",
            fontFamily: "monospace",
            fontSize: "13.33px",
            borderTop: "1px solid rgb(203, 203, 202)",
          }}
        >
          <div>Количество символов:</div>
          <div style={{ paddingLeft: "2px" }} ref={counter}>
            {countChars}
          </div>
        </div>
      </div>
    </Tooltip>
  );
}
